import { TElement, TReactEditor } from '@udecode/plate';
import { Editor, Transforms } from 'slate';

export const resetEditorValue = (nextValue: TElement[], editor: TReactEditor) => {
  if (editor) {
    Transforms.deselect(editor);
    editor.children = nextValue;
    editor.history = { undos: [], redos: [] };
    const lastPoint = Editor.end(editor, []);
    Transforms.select(editor, { anchor: lastPoint, focus: lastPoint });
  }
};
